import React from 'react';
import { SaveButton, Toolbar } from 'react-admin';
import CancelButton from './CancelButton'

const EditConfirmToolbar = props => {

    function handleSave() {
        try {
            props.history.goBack()
        } catch (e) {
            console.warn(e)
        }
    }

    return (
        <Toolbar {...props} pristine={false}  >
            <SaveButton
                label="save"
                redirect="show"
                submitOnEnter={true}
                onSuccess={handleSave}
            />
            <CancelButton history={props.history} />
        </Toolbar>
    );
}

export default EditConfirmToolbar;